module.exports = __webpack_public_path__ + "img/a9_08.d6e27394.jpg";